import httpClient from '../../httpClient';

export const refundCashPayment = (paymentId) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/payments/${paymentId}/cash/refund`,
  });
};

export const refundStripePayment = (paymentId) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/payments/${paymentId}/stripe/refund`,
  });
};

export const captureStripePayment = (paymentId) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/payments/${paymentId}/stripe/capture`,
  });
};

export const getPayments = (pageNumber, searchString) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/payments?pageNumber=${pageNumber}&searchTerm=${searchString}`,
  });
};

export const getPayment = (id, orderId = null) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/payments/${id}`,
    params: {
      orderId,
    },
  });
};
